<template>
  <div class="login" v-if="visible">
    <div class="login__panel" @click.stop>
      <hr class="login__line" />
      <div class="login__content">
        <template>
          <div class="login__brand">
            <img src="@/assets/imgs/logo.png" alt="" />
            <span>{{ $t('message.login.brandName') }}</span>
          </div>
          <div class="login__form">
            <div class="login__form_item">
              <span class="area global_pointer" @click="chooseCountryCode">+{{ countryCode }}</span>
              <input
                type="text"
                v-model="mobile"
                :placeholder="$t('message.login.mobile')"
                maxLength="11"
                minLength="11"
                @blur="onBlur"
                @focus="onFocus"
              />
            </div>
            <div class="login__form_item">
              <span class="area-code">&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <input
                class="vcode"
                type="text"
                v-model="checkCode"
                :placeholder="$t('message.login.verifyCode')"
                maxLength="6"
                minLength="6"
                @blur="onBlur"
                @focus="onFocus"
              />
              <div
                class="login__form_button-vcode global_pointer"
                :class="{ disable: codeDisable }"
                @click="sendVCode"
              >
                {{ countTime == 60 ? $t('message.login.getVerifyCode') : ''
                }}{{ countTime < 60 ? '(' + countTime + ')' : '' }}
              </div>
            </div>
            <div class="login__form_item login__form_item-button global_pointer" @click="mobileLogin">
              确认绑定
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="login__code_select" v-if="showCountryCode">
      <div class="country-code-box">
        <div class="country-code" v-for="(item, index) in phoneCodeList" :key="index">
          <p class="title">{{ en ? item.title:item.titleZh }}</p>
          <ul class="item-list">
            <li class="global_pointer"
              v-for="(itemCode, indexCode) in item.list"
              :key="indexCode"
              @click="chooseNum(itemCode.code)"
            >
              <span class="name">{{ en ? itemCode.name:itemCode.nameZh }}</span>
              <span class="code">+{{ itemCode.code }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.5);
  text-align: center;
  &__panel {
    position: absolute;
    width: 100%;
    background: #ffffff;
    left: 0;
    bottom: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    overflow: hidden;
    z-index: 110;
    &_close{
      width: 26px;
      height: 26px;
      position: absolute;
      right: 12px;
      top: 12px;
    }
  }
  &__line {
    border: 0;
    padding: 0;
    margin: 0;
    width: 100%;
    height: 8px;
    background: #c0ddde;
  }
  &__brand {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 28px;
    margin-bottom: 24px;
    & img {
      width: 60px;
      height: 60px;
      border-radius: 100%;
      margin-bottom: 8px;
    }
    & span {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #333333;
      line-height: 20px;
    }
  }
  &__form {
    margin-bottom: 37px;
  }
  &__form_item {
    background: #f5f5f5;
    border-radius: 18px;
    border: 1px solid #f2f2f2;
    width: 243px;
    height: 36px;
    line-height: 36px;
    margin: 0 auto 16px;
    box-sizing: border-box;
    text-align: left;
    padding: 0 11px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    & .area {
      height: 19px;
      line-height: 19px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #161a1a;
    }
    & input {
      border: 0;
      width: 135px;
      height: 19px;
      line-height: 19px;
      border-radius: 0;
      padding: 0 6px;
      margin-left: 6px;
      border-left: 1px solid #979797;
      background-color: transparent !important;
      outline: none;
      &.vcode {
        border-left: 0;
        padding-left: 0;
        margin-left: 0;
      }
    }
    &_container{
      background-color: transparent;
      justify-content: space-between;
      padding: 0;
      border: 0;
    }
  }
  &__form_button-vcode {
    width: 83px;
    height: 28px;
    line-height: 28px;
    display: inline-block;
    background: #000000;
    border-radius: 22px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    text-align: center;
    position: relative;
    right: -7px;
    word-break: keep-all;
    white-space: nowrap;
  }
  &__form_button-forgot {
    // width: 83px;
    height: 20px;
    line-height: 20px;
    display: inline-block;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #4A4A4A;
    text-align: center;
    position: relative;
    // right: -7px;
    word-break: keep-all;
    white-space: nowrap;
    text-decoration: underline;
  }
  &__form_item-button {
    border: 0;
    background: #000000;
    border-radius: 22px;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #ffffff;
    justify-content: center;
    &-half{
      width: 118px;
    }
    &-sign_up{
      color: #000000;
      background-color: #ffffff;
      border-radius: 22px;
      border: 1px solid #000000;
    }
  }
  &__other {
    &-head {
      border-top: 1px solid #dcd3c2;
      width: 325px;
      margin: 48px auto 0;
      & div {
        display: inline-block;
        height: 22px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #999999;
        line-height: 22px;
        position: relative;
        top: -11px;
        background: #ffffff;
        padding: 0 20px;
      }
    }
  }
  .disable {
    background: #3d3c3c;
  }
  &__code_select {
    position: absolute;
    z-index: 200;
    width: 100%;
    background: #ffffff;
    left: 0;
    bottom: 0;
    border-top: 0.5px solid #aaaaaa;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    height: 200px;
    overflow-y: scroll;
    .country-code-box {
      text-align: left;
      .country-code {
        padding: 20px;
        p {
          margin-bottom: 10px;
          font-size: 10px;
          font-weight: bolder;
        }
        ul {
          li {
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            border-bottom: 0.5px solid #e3e3e3;
            span {
              font-size: 12px;
            }
            .name {
              width: 60%;
            }
            .code {
              text-align: right;
              width: 30%;
            }
          }
        }
      }
    }
  }
}
</style>
<script>
import api from '@/api/api_list';
import { getDeviceId, plateForm } from '@/utils';
import phoneCodezh from '@/config/PhoneCodezh.json';
import phoneCode from '@/config/PhoneCode.json';

const isWx = plateForm().os === 'wxClient';
export default {
  name: 'login',
  data() {
    return {
      mobile: '',
      checkCode: '',
      interval: 0,
      countTime: 60,
      codeDisable: false,
      relationInfo: null,
      countryCode: this.$i18n.locale === 'en' ? 1:86,
      en: this.$i18n.locale === 'en',
      phoneCodeList: this.$i18n.locale === 'en' ? phoneCode.data : phoneCodezh.data,
      showCountryCode: false,
      isWx,
      visible: false,
      complete:null,
      inviteCode:null,
      token: null,
      userInfo: null,
    };
  },
  mounted() {
  },
  methods: {
    sendVCode() {
      if (this.countTime < 60) {
        return;
      }
      let mobileReg = new RegExp(/^\d+$/g)
      if (!this.mobile || !this.en && this.mobile.length!=11 || !mobileReg.test(this.mobile)) {
        this.$toast(this.$t('message.login.tips.yourNumber'));
        return;
      }
      this.codeDisable = true;
      api
        .send_v_code({
          countryCode: this.countryCode,
          mobile: this.mobile,
        })
        .then((res) => {
          if(res.code == 0){
            this.setCountDown(res)
          }else{
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          this.countTime = 60;
          this.codeDisable = false;
        });
    },
    setCountDown(res){
      if (res.code === 0) {
        const _this = this;
        this.interval = setInterval(() => {
          _this.countTime -= 1;
          if (_this.countTime <= 0) {
            this.resetInterval()
          }
        }, 1000);
      } else {
        this.resetInterval()
        this.$toast(res.msg);
      }
    },
    mobileLogin() {
      let mobileReg = new RegExp(/^\d+$/g)
      if (!this.mobile || !this.checkCode || !mobileReg.test(this.mobile)) {
        this.$toast(this.$t('message.login.tips.correctInfo'));
        return;
      }


      if (this.token == null) {
        this.token = this.$storage.get('user_token')
      }

      if (this.userInfo == null) {
        this.userInfo = this.$storage.get('user_info')
      }
   let bindMobileSource = 0;
      if (this.userInfo.userWeixinId) {
        bindMobileSource = 0;
      }else if(this.userInfo.userAppleId){
        bindMobileSource = 1;
      }else if(this.userInfo.userPartyId){
        bindMobileSource = 3;
      }

      let params = {
          mobile: this.mobile,
          checkCode: this.checkCode,
          countryCode: this.countryCode,
          token: this.token,
          userWeixinId: this.userInfo.userWeixinId ? this.userInfo.userWeixinId : null,
          userAppleId: this.userInfo.userAppleId ? this.userInfo.userAppleId : null,
          userPartyId: this.userInfo.userPartyId ? this.userInfo.userPartyId : null,
          bindMobileSource,
          inviteCode: this.inviteCode
      }
      api
        .bind_mobile(params)
        .then((res) => {
          if(res.code == 0){
            this.setUser(res.result);
          }else{
            this.$toast(res.msg)
          }
        });
    },
    async setUser(userInfo = {}) {
      const setInfo = (token, intgUser) => {
        if (!token || !intgUser) {
          return;
        }
        this.$storage.set('user_token', token);
        this.$storage.set('user_info', intgUser);
        this.visible = false

        // this.$emit('login-success');
      };
      const { token, intgUser } = userInfo;
      setInfo(token, intgUser, true);

      this.complete ? this.complete() : null ;
    },
    chooseCountryCode() {
      this.showCountryCode = true;
    },
    closeCountryCode() {
      this.showCountryCode = false;
    },
    chooseNum(code) {
      this.countryCode = code;
      this.closeCountryCode();
    },
    onFocus(evt) {
      // setTimeout(() => {
      //   document.getElementsByTagName('body')[0].style.height = `${window.innerHeight + 302}px`;
      //   document.body.scrollTop = 302;
      // }, 300);
      let element = evt.target
      element.scrollIntoView(true);
      element.scrollIntoViewIfNeeded(true);
    },
    // 输入框失去焦点事件
    onBlur() {
      // 设置body恢复原来的高度
      // document.getElementsByTagName('body')[0].style.height = `${window.innerHeight}px`;
    },
    resetInterval(){
      clearInterval(this.interval)
      this.countTime = 60;
      this.codeDisable = false;
    },
    resetForm(){
      this.checkCode = ''
      this.mobile = ''
    },
    open(input = {}){
      let {bindComplete, token, userInfo} = input
      this.resetForm()
      this.resetInterval()
      this.visible = true

      this.complete = bindComplete
      this.token = token;
      this.userInfo = userInfo;

      let inviteInfoStr = sessionStorage.getItem("inviteInfo");
      if (inviteInfoStr!=null) {
            let inviteInfo = JSON.parse(inviteInfoStr)
            if (inviteInfo==null
                ||inviteInfo.activityType!='inviteCode') {
                return
            }
            this.inviteCode = inviteInfo.code
      }
    }
  },
  watch: {
    visible: function(newV, oldV) {
      sessionStorage.setItem('bindMobileVisible', newV);
    }
  }
};
</script>
